import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const validSpacing = PropTypes.oneOf([0, 4, 8, 12, 16, 20, 24, 28, 32, 40, 50]);

/** Provides several preset spacing options so you don't have to write the CSS (ain't got no time for that) */
const Spacer = props => {
    const {
        as: Component,
        bottom,
        className,
        left,
        margin,
        padding,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop,
        right,
        top,
        ...otherProps
    } = props;

    const classes = cx(
        margin && `spacer--${margin}`,
        top && `spacer__top--${top}`,
        bottom && `spacer__bottom--${bottom}`,
        left && `spacer__left--${left}`,
        right && `spacer__right--${right}`,
        padding && `spacer__pad--${padding}`,
        paddingTop && `spacer__padTop--${paddingTop}`,
        paddingBottom && `spacer__padBottom--${paddingBottom}`,
        paddingLeft && `spacer__padLeft--${paddingLeft}`,
        paddingRight && `spacer__padRight--${paddingRight}`,
        className
    );

    return <Component className={classes} {...otherProps} />;
};

Spacer.displayName = 'Spacer';

Spacer.propTypes = {
    /** Specifies the root component. Can be an HTML element or React component. */
    as: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /** Sets the `margin-bottom` CSS property in pixels */
    bottom: validSpacing,
    className: PropTypes.string,
    /** Sets the `margin-left` CSS property in pixels */
    left: validSpacing,
    /** Sets the `margin` CSS property in pixels */
    margin: validSpacing,
    /** Sets the `padding` CSS property in pixels */
    padding: validSpacing,
    /** Sets the `padding-bottom` CSS property in pixels */
    paddingBottom: validSpacing,
    /** Sets the `padding-left` CSS property in pixels */
    paddingLeft: validSpacing,
    /** Sets the `padding-right` CSS property in pixels */
    paddingRight: validSpacing,
    /** Sets the `padding-top` CSS property in pixels */
    paddingTop: validSpacing,
    /** Sets the `margin-right` CSS property in pixels */
    right: validSpacing,
    /** Sets the `margin-top` CSS property in pixels */
    top: validSpacing
};

Spacer.defaultProps = {
    as: 'div'
};

export default Spacer;
